<!--
/*******************************************************************************
*@ 컴포넌트명   : Drwot.vue
*@ 컴포넌트설명 : 출금계좌 selectbox - option에 사용되는 template
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div>
    <span class="stit">{{data.alias}}</span>
    {{data.acno}} ({{data.cncycd}})
    <div class="amount highlight">
      <span class="exchange-unit">{{data.cncycd}}</span>
      <span class="total" v-html="$num(data.dpostBal)"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
  },
};
</script>